import { useMemo } from 'react';
import { Variable } from 'src/api/types';
import { useAuth } from 'src/state/auth';
import { useWorkspaceVariablesQuery } from 'src/graphql/_generated';

const useWorkspaceVariables = () => {
  const { workspaceId } = useAuth();

  const { data, loading } = useWorkspaceVariablesQuery({
    variables: { id: workspaceId! },
    skip: !workspaceId,
  });

  const variables: Variable[] = useMemo(
    () =>
      data?.workspace?.variables?.map(
        (el) =>
          ({
            id: el.id!,
            name: el.name!,
            value: el.value!,
            currency: el.currency,
            isInUse: el.isInUse as string[],
            workspace_variable: !!el.workspaceVariable,
            alias: el.alias || null,
            isGlobal: !!el.isGlobal,
          }) satisfies Variable,
      ) || [],
    [data],
  );

  return { variables, isLoading: loading };
};

export default useWorkspaceVariables;
